import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Sale01 from '../components/sale/Sale01';
import { landingApi } from '../api/landing-api';

const levelBadge = {
  BEGINNER: { label: 'Pemula', color: '#58bd7d', bg: 'rgba(88,189,125,0.15)' },
  INTERMEDIATE: { label: 'Menengah', color: '#0C8F86', bg: 'rgba(12,143,134,0.15)' },
  ADVANCED: { label: 'Mahir', color: '#f59e0b', bg: 'rgba(245,158,11,0.15)' },
};

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:4000/api/v1';

const levelIcons = {
  BEGINNER: '🌱',
  INTERMEDIATE: '📈',
  ADVANCED: '🚀',
};

function AcademyPage() {
  const [courses, setCourses] = useState([]);
  const [activeLevel, setActiveLevel] = useState('ALL');
  const [searchQuery, setSearchQuery] = useState('');
  const FE_WEB_URL = 'https://app.tradiora.id';

  useEffect(() => {
    landingApi.getAcademyCourses().then((res) => {
      if (res?.data?.courses?.length) setCourses(res.data.courses);
    }).catch(() => {});
  }, []);

  const filtered = courses.filter(c => {
    if (activeLevel !== 'ALL' && c.level !== activeLevel) return false;
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      return c.title.toLowerCase().includes(q) || c.description?.toLowerCase().includes(q);
    }
    return true;
  });

  const defaultThumbnails = [
    'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=600&q=80',
    'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=600&q=80',
    'https://images.unsplash.com/photo-1617900906639-cab7ad7b296e?w=600&q=80',
    'https://images.unsplash.com/photo-1642790106117-e829e14a795f?w=600&q=80',
  ];

  return (
    <div>
      <section style={{
        padding: '120px 0 80px',
        background: 'linear-gradient(135deg, #0a1628 0%, #0d1f3c 30%, #0C8F86 100%)',
        position: 'relative',
        overflow: 'hidden',
      }}>
        <div style={{
          position: 'absolute', top: '-20%', right: '-10%', width: 500, height: 500,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(12,143,134,0.12) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
        <div style={{
          position: 'absolute', bottom: '-15%', left: '-5%', width: 400, height: 400,
          borderRadius: '50%', background: 'radial-gradient(circle, rgba(139,92,246,0.1) 0%, transparent 70%)',
          pointerEvents: 'none',
        }} />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="row">
            <div className="col-md-12">
              <div style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto' }}>
                <div style={{
                  display: 'inline-flex', alignItems: 'center', gap: 4,
                  background: 'rgba(12,143,134,0.15)', borderRadius: 20,
                  padding: '6px 16px', marginBottom: 16,
                }}>
                  <span style={{ color: 'var(--primary)', fontSize: 10 }}>✦</span>
                  <span style={{ color: 'var(--primary)', fontSize: 13, fontWeight: 600 }}>Akademi Investasi</span>
                </div>
                <h1 style={{
                  fontSize: 44, fontWeight: 800, color: '#fff', lineHeight: 1.15, marginBottom: 16,
                  letterSpacing: '-1px',
                }}>
                  Kuasai Investasi dari Dasar hingga Mahir
                </h1>
                <p className="fs-20" style={{ color: 'rgba(255,255,255,0.65)', lineHeight: 1.7, marginBottom: 32 }}>
                  Materi terstruktur, studi kasus nyata, dan bimbingan mentor untuk setiap level trader
                </p>
                <div className="row" style={{ marginBottom: 0 }}>
                  <div className="col-md-8 offset-md-2">
                    <div style={{ position: 'relative' }}>
                      <span style={{
                        position: 'absolute', left: 18, top: '50%', transform: 'translateY(-50%)',
                        color: 'rgba(255,255,255,0.4)', fontSize: 18, pointerEvents: 'none', zIndex: 2,
                      }}>🔍</span>
                      <input
                        type="text"
                        placeholder="Cari kursus..."
                        value={searchQuery}
                        onChange={e => setSearchQuery(e.target.value)}
                        style={{
                          width: '100%', padding: '16px 24px 16px 52px', borderRadius: 60,
                          border: '1px solid rgba(255,255,255,0.1)', background: 'rgba(255,255,255,0.08)',
                          color: '#fff', fontSize: 15, outline: 'none',
                          transition: 'all 0.3s', backdropFilter: 'blur(12px)',
                        }}
                        onFocus={e => { e.target.style.background = 'rgba(255,255,255,0.14)'; e.target.style.borderColor = 'var(--primary)'; }}
                        onBlur={e => { e.target.style.background = 'rgba(255,255,255,0.08)'; e.target.style.borderColor = 'rgba(255,255,255,0.1)'; }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="services" style={{ padding: '80px 0', position: 'relative', background: 'var(--bg)' }}>
        <div className="container">

          <div className="row" style={{ marginBottom: 40 }}>
            <div className="col-md-12">
              <div style={{ display: 'flex', justifyContent: 'center', gap: 10, flexWrap: 'wrap' }}>
                {['ALL', 'BEGINNER', 'INTERMEDIATE', 'ADVANCED'].map((level) => {
                  const isActive = activeLevel === level;
                  const badge = levelBadge[level];
                  return (
                    <button
                      key={level}
                      onClick={() => setActiveLevel(level)}
                      style={{
                        padding: '10px 24px',
                        borderRadius: 60,
                        border: isActive ? `1.5px solid ${badge?.color || 'var(--primary)'}` : '1.5px solid var(--line)',
                        fontWeight: 700,
                        fontSize: 13,
                        cursor: 'pointer',
                        background: isActive
                          ? `linear-gradient(135deg, ${badge?.color || 'var(--primary)'}, ${badge?.color || 'var(--primary)'}dd)`
                          : 'var(--surface)',
                        color: isActive ? '#fff' : 'var(--text)',
                        transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                        backdropFilter: 'blur(10px)',
                        letterSpacing: '0.3px',
                      }}
                      onMouseEnter={e => {
                        if (!isActive) {
                          e.currentTarget.style.background = 'var(--line)';
                          e.currentTarget.style.color = 'var(--onsurface)';
                        }
                      }}
                      onMouseLeave={e => {
                        if (!isActive) {
                          e.currentTarget.style.background = 'var(--surface)';
                          e.currentTarget.style.color = 'var(--text)';
                        }
                      }}
                    >
                      {level !== 'ALL' && <span style={{ marginRight: 6 }}>{levelIcons[level]}</span>}
                      {level === 'ALL' ? 'Semua Level' : badge?.label || level}
                    </button>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="row">
            {filtered.map((course, index) => {
              const thumb = course.thumbnail
                ? (course.thumbnail.startsWith('http') ? course.thumbnail : `${API_BASE}/public/uploads${course.thumbnail}`)
                : defaultThumbnails[index % defaultThumbnails.length];
              const level = levelBadge[course.level];
              const mentorName = course.mentor?.fullName || course.mentor?.name || '';
              const mentorInitials = mentorName ? mentorName.split(' ').map(n => n[0]).join('').slice(0, 2) : '';

              return (
                <div className="col-xl-4 col-md-6" key={course.id || index} style={{ marginBottom: 24 }} data-aos="fade-up" data-aos-delay={(index % 3) * 80}>
                  <div style={{
                    background: 'var(--surface)',
                    borderRadius: 20,
                    overflow: 'hidden',
                    height: '100%',
                    border: '1px solid var(--line)',
                    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                    onMouseEnter={e => {
                      e.currentTarget.style.transform = 'translateY(-8px)';
                      e.currentTarget.style.borderColor = 'rgba(12,143,134,0.3)';
                      e.currentTarget.style.boxShadow = '0 24px 60px rgba(12,143,134,0.15)';
                      e.currentTarget.style.background = 'var(--bg1)';
                    }}
                    onMouseLeave={e => {
                      e.currentTarget.style.transform = '';
                      e.currentTarget.style.borderColor = 'var(--line)';
                      e.currentTarget.style.boxShadow = '';
                      e.currentTarget.style.background = 'var(--surface)';
                    }}
                  >
                    {/* Thumbnail */}
                    <div style={{ position: 'relative', overflow: 'hidden', aspectRatio: '16/9' }}>
                      <img
                        src={thumb}
                        alt={course.title}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = 'scale(1.06)'; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = 'scale(1)'; }}
                        onError={e => {
                          e.currentTarget.style.display = 'none';
                          e.currentTarget.parentElement.style.background = 'linear-gradient(135deg, #0d1f3c, #1a0f2e)';
                        }}
                      />
                      {/* Gradient overlay */}
                      <div style={{
                        position: 'absolute', inset: 0,
                        background: 'linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.7) 100%)',
                        pointerEvents: 'none',
                      }} />

                      {/* Category badge */}
                      <div style={{
                        position: 'absolute', top: 14, left: 14,
                        display: 'flex', alignItems: 'center', gap: 6,
                        background: 'rgba(0,0,0,0.5)',
                        backdropFilter: 'blur(8px)',
                        borderRadius: 10,
                        padding: '6px 14px',
                      }}>
                        <span style={{ color: '#fff', fontSize: 10 }}>📚</span>
                        <span style={{ color: '#fff', fontWeight: 600, fontSize: 11 }}>
                          {course.category?.name || 'Akademi'}
                        </span>
                      </div>

                      {/* Level badge */}
                      <div style={{
                        position: 'absolute', bottom: 14, left: 14,
                        display: 'flex', alignItems: 'center', gap: 5,
                        background: level?.bg || 'rgba(12,143,134,0.2)',
                        borderRadius: 8, padding: '4px 12px',
                        border: `1px solid ${level?.color || 'var(--primary)'}40`,
                      }}>
                        <span style={{ fontSize: 12 }}>{levelIcons[course.level] || '📖'}</span>
                        <span style={{ color: level?.color || '#fff', fontWeight: 700, fontSize: 11 }}>
                          {level?.label || course.level}
                        </span>
                      </div>

                      {/* Price tag */}
                      <div style={{
                        position: 'absolute', bottom: 14, right: 14,
                        background: 'rgba(0,0,0,0.6)',
                        backdropFilter: 'blur(8px)',
                        borderRadius: 8, padding: '4px 12px',
                      }}>
                        <span style={{ color: '#fff', fontWeight: 700, fontSize: 12 }}>
                          {course.accessType === 'FREE' ? 'Gratis' : course.price > 0 ? `Rp ${Number(course.price).toLocaleString()}` : 'Premium'}
                        </span>
                      </div>
                    </div>

                    {/* Content */}
                    <div style={{ padding: '20px 22px 24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <h5 style={{
                        fontSize: 17, fontWeight: 700, color: 'var(--onsurface)', marginBottom: 10,
                        lineHeight: 1.4, display: '-webkit-box',
                        WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                      }}>
                        {course.title}
                      </h5>

                      <p style={{
                        fontSize: 13, color: 'var(--text)', lineHeight: 1.7, marginBottom: 16,
                        display: '-webkit-box',
                        WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden',
                      }}>
                        {course.description}
                      </p>

                      {/* Stats row */}
                      <div style={{
                        display: 'flex', gap: 16, marginBottom: 16,
                        padding: '12px 14px',
                        background: 'var(--bg)',
                        borderRadius: 12,
                        border: '1px solid var(--line)',
                      }}>
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ color: 'var(--primary)', fontSize: 15, fontWeight: 800 }}>
                            {course._count?.lessons || 0}
                          </div>
                          <div style={{ color: 'var(--text)', fontSize: 11 }}>Pelajaran</div>
                        </div>
                        <div style={{ width: 1, background: 'var(--line)' }} />
                        <div style={{ flex: 1, textAlign: 'center' }}>
                          <div style={{ color: '#f59e0b', fontSize: 15, fontWeight: 800 }}>
                            {course.level === 'BEGINNER' ? 'Dasar' : course.level === 'INTERMEDIATE' ? 'Menengah' : 'Mahir'}
                          </div>
                          <div style={{ color: 'var(--text)', fontSize: 11 }}>Level</div>
                        </div>
                      </div>

                      {/* Mentor */}
                      {mentorName && (
                        <div style={{
                          display: 'flex', alignItems: 'center', gap: 10, marginBottom: 18,
                          padding: '8px 12px',
                          background: 'var(--bg)',
                          borderRadius: 10,
                        }}>
                          <div style={{
                            width: 32, height: 32, borderRadius: '50%',
                            background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            color: '#fff', fontSize: 12, fontWeight: 700, flexShrink: 0,
                          }}>
                            {mentorInitials}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ color: 'var(--text)', fontSize: 10 }}>Mentor</div>
                            <div style={{ color: 'var(--onsurface)', fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {mentorName}
                            </div>
                          </div>
                          <span style={{ color: '#f59e0b', fontSize: 12 }}>★ 4.9</span>
                        </div>
                      )}

                      {/* CTA */}
                      <div style={{ marginTop: 'auto' }}>
                        <Link
                          to={`/academy/${course.slug || course.id}`}
                          style={{
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
                            width: '100%',
                            background: 'linear-gradient(135deg, var(--primary), #0a6b64)',
                            color: '#fff', fontWeight: 700, fontSize: 14,
                            borderRadius: 12, padding: '12px 20px',
                            textDecoration: 'none', border: '1px solid rgba(255,255,255,0.08)',
                            transition: 'all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
                          }}
                          onMouseEnter={e => {
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 8px 24px rgba(12,143,134,0.3)';
                          }}
                          onMouseLeave={e => {
                            e.currentTarget.style.transform = '';
                            e.currentTarget.style.boxShadow = '';
                          }}
                        >
                          Mulai Belajar
                          <span style={{ fontSize: 16 }}>→</span>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {filtered.length === 0 && (
            <div style={{ textAlign: 'center', padding: '80px 20px' }}>
              <div style={{ fontSize: 48, marginBottom: 16 }}>📚</div>
              <h4 style={{ color: 'var(--onsurface)', fontSize: 20, fontWeight: 700, marginBottom: 8 }}>
                {searchQuery ? `Hasil untuk "${searchQuery}" tidak ditemukan` : 'Belum ada kursus'}
              </h4>
              <p style={{ color: 'var(--text)', fontSize: 15, marginBottom: 24 }}>
                {searchQuery
                  ? 'Coba gunakan kata kunci lain atau sesuaikan filter'
                  : 'Belum ada kursus untuk level yang dipilih. Coba level lain.'}
              </p>
              {searchQuery && (
                <button
                  onClick={() => { setSearchQuery(''); setActiveLevel('ALL'); }}
                  style={{
                    padding: '10px 28px', borderRadius: 12, border: 'none',
                    background: 'var(--surface)', color: 'var(--onsurface)',
                    fontWeight: 600, cursor: 'pointer', fontSize: 14,
                  }}
                >
                  Reset Filter
                </button>
              )}
            </div>
          )}
        </div>
      </section>

      <section style={{ padding: '0 0 80px' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div style={{
                background: 'linear-gradient(135deg, rgba(12,143,134,0.08), rgba(139,92,246,0.08))',
                borderRadius: 24,
                padding: '56px 48px',
                textAlign: 'center',
                border: '1px solid var(--line)',
                position: 'relative',
                overflow: 'hidden',
              }}>
                <div style={{
                  position: 'absolute', top: '-30%', right: '-10%', width: 300, height: 300,
                  borderRadius: '50%', background: 'rgba(12,143,134,0.08)', filter: 'blur(50px)',
                }} />
                <div style={{ position: 'relative', zIndex: 1 }}>
                  <span style={{ fontSize: 48, marginBottom: 16, display: 'block' }}>🎯</span>
                  <h3 style={{ color: 'var(--onsurface)', fontSize: 28, fontWeight: 800, marginBottom: 12 }}>
                    Butuh Bimbingan Langsung?
                  </h3>
                  <p style={{ color: 'var(--text)', fontSize: 16, maxWidth: 520, margin: '0 auto 32px', lineHeight: 1.7 }}>
                    Dapatkan akses ke semua kursus akademi plus sesi mentoring 1-on-1 eksklusif dengan menjadi Premium Member Tradiora.
                  </p>
                  <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Link to="/pricing" style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      background: 'linear-gradient(135deg, var(--primary), #8b5cf6)',
                      color: '#fff', fontWeight: 700, fontSize: 15,
                      borderRadius: 14, padding: '14px 32px', textDecoration: 'none',
                      transition: 'all 0.3s',
                    }}
                      onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 30px rgba(139,92,246,0.3)'; }}
                      onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = ''; }}
                    >
                      Lihat Paket Member
                    </Link>
                    <a href={FE_WEB_URL} style={{
                      display: 'inline-flex', alignItems: 'center', gap: 8,
                      background: 'var(--surface)', color: 'var(--onsurface)',
                      fontWeight: 600, fontSize: 15, borderRadius: 14,
                      padding: '14px 32px', textDecoration: 'none',
                      border: '1px solid var(--line)',
                      transition: 'all 0.3s',
                    }}
                      onMouseEnter={e => { e.currentTarget.style.background = 'var(--line)'; }}
                      onMouseLeave={e => { e.currentTarget.style.background = 'var(--surface)'; }}
                    >
                      Daftar Gratis
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Sale01 />
    </div>
  );
}

export default AcademyPage;
